export default __webpack_public_path__ + "static/media/lodgify_step1.2d7b73b5.jpg";